module.exports = __webpack_public_path__ + "assets/img/VIPBenefits.8d35b8da.png";